import fetcher, { fetchWithToken } from '@/services/fetcher'

const GET_ORDER_STATUS = `
query getOrderStatus($order_number: String!) {
  getOrderStatus(order_number: $order_number) {
    state
    status
  }
}`

const GET_ORDER_INFO_PLACEORDER = `
query getOrderInfoPlaceOrder($order_number: String!) {
  getOrderInfoPlaceOrder(order_number: $order_number) {
    payment {
      account
      account_note
      account_number
      bank
      bank_id
      bank_logo
      qr_logo
    }
    orderV2 {
      entity_id
      order_number
      expire_at
      grand_total {
        currency
        value
      }
      protect_code
    }
  }
}`
const GET_ORDER_INFO_PLACEORDER_V2 = `
query getOrderInfoPlaceOrder($order_number: String!) {
  getOrderInfoPlaceOrder(order_number: $order_number) {
    payment {
      account
      account_note
      account_number
      bank
      bank_id
      bank_logo
      qr_logo
    }
    orderV2 {
       entity_id
      order_number
      expire_at
      grand_total {
        currency
        value
      }
      affiliate_information {
        cashback
      }
      items{
      attributes {
          label
          option_id
          option_value
          value
        } 
        quantity
          prices {
            row_total{
              currency
              value
            }
            price {
              currency
              value
            }
          }
        product {
          attribute_set_id
          created_at
          id
          image {
            disabled
            label
            position
            url
          }
          media_gallery {
            disabled
            label
            position
            url
          }
          name
          price_range {
            maximum_price {
              discount {
                amount_off
              }
              final_price {
                 currency
                value
              }
              regular_price {
                currency
                value
              }
            }
          }
          shirt_back
          sku
          sort_name
          stock_status
          type_id
          uid
          updated_at
          url_key
        } 
        
      }
      protect_code
    }
  }
}`
const GET_UPSELL_OFFERS = `
query getUpsellOffers($orderID:Int!){
  getUpsellOffers(order_id: $orderID) {
    order_id
    expire_after_date
    expire_after_minutes
     affiliate_information {
      cashback
    }
    offers {
      offer_id
      rule_name
      product_sku
      product_name
      product_image
       attributes {
        label
        option_id
        option_value
        value
      }
      offer_type
      add_qty
      discount_type
      discount_value
      checkout_price
      final_price
      estimated_saving
      priority
      title
      description
      expire_after_minutes
      expire_after_date
      max_discount_applied
    }
  }
}`

const PLACE_ORDER_UPSELL_OFFERS = `
mutation placeOrderUpsellOffers($order_id: Int!, $selected_offers: [String]!) {
  placeOrderUpsellOffers(order_id: $order_id, selected_offers: $selected_offers) {
    payment {
      account
      account_note
      account_number
      bank
      bank_id
      bank_logo
      qr_logo
    }
    orderV2 {
      entity_id
      order_number
      grand_total {
        currency
        value
      }
      protect_code
    }
  }
}`

const GET_ORDER_INFO_BY_PROTECT_CODE = `
query getOrderInfoByProtectCode($protect_code: String!) {
  getOrderInfoByProtectCode(protect_code: $protect_code) {
    order {
      carrier
      created_at
      customer_email
      grand_total
      id
      increment_id
      number
      order_date
      order_number
      shipping_method
      state
      status
      discount_description {
        amount {
          currency
          value
        }
        discount_amount
        label
        rule_id
        type
      }
      shipping_address {
        address_note
        city
        city_id
        company
        country_code
        district
        district_id
        firstname
        lastname
        middlename
        street
        telephone
        ward
        ward_id
      }
      billing_address {
        address_note
        city
        city_id
        company
        country_code
        district
        district_id
        firstname
        lastname
        middlename
        street
        telephone
        ward
        ward_id
      }
      total {
        discounts {
          discount_amount
          label
          type
          amount {
            currency
            value
          }
        }
        subtotal {
          currency
          value
        }
        total_shipping {
          currency
          value
        }
        grand_total {
          currency
          value
        }
      }
      products {
        id
        product_image
        product_name
        product_sku
        product_url_key
        quantity_ordered
        selected_options {
          label
          value
        }
        discounts {
          discount_amount
          label
          type
          amount {
            currency
            value
          }
        }
        product_sale_price {
          currency
          value
        }
      }
    }
  }
}`

export const getQrPayment = async (params: {
  accountNo?: any
  accountName?: any
  acqId?: any
  amount?: any
  addInfo?: string
  format?: string
  template?: string
}) => {
  try {
    const qrPayment = await fetcher.post(
      '/v2/generate',
      { ...params },
      {
        baseUrl: 'https://api.vietqr.io',
      }
    )
    return qrPayment.payload as IQrData
  } catch (error) {
    throw error
  }
}

export const getOrderStatus = async (order_number: string) => {
  try {
    const response = await fetchWithToken({
      query: GET_ORDER_STATUS,
      variables: { order_number },
    })
    if (response.payload.errors) {
      throw new Error(response.payload.errors[0].message)
    }
    return response.payload.data.getOrderStatus
  } catch (error) {
    throw error
  }
}

export const getOrderInfoPlaceOrder = async (order_number: string) => {
  try {
    const response = await fetchWithToken({
      query: GET_ORDER_INFO_PLACEORDER_V2,
      variables: { order_number },
    })
    if (response.payload.errors) {
      throw new Error(response.payload.errors[0].message)
    }
    return response.payload.data.getOrderInfoPlaceOrder as IOrderInfoPlaceOrder
  } catch (error) {
    throw error
  }
}

export const getUpsellOffers = async (orderID: number) => {
  try {
    const response = await fetchWithToken({
      query: GET_UPSELL_OFFERS,
      variables: { orderID },
    })
    if (response.payload.errors) {
      throw new Error(response.payload.errors[0].message)
    }
    return response.payload.data.getUpsellOffers as IOfferOrderResponse
  } catch (error) {
    throw error
  }
}

export const placeOrderUpsellOffers = async (order_id: number, selected_offers: string[]) => {
  try {
    const response = await fetchWithToken({
      query: PLACE_ORDER_UPSELL_OFFERS,
      variables: { order_id, selected_offers },
    })
    if (response.payload.errors) {
      throw new Error(response.payload.errors[0].message)
    }
    return response.payload.data.placeOrderUpsellOffers
  } catch (error) {
    throw error
  }
}

export const getOrderInfoByProtectCode = async (protect_code: string) => {
  try {
    const response = await fetchWithToken({
      query: GET_ORDER_INFO_BY_PROTECT_CODE,
      variables: { protect_code },
    })
    if (response.payload.errors) {
      throw new Error(response.payload.errors[0].message)
    }
    return response.payload.data.getOrderInfoByProtectCode.order as IOrderInfoByProtectCode
  } catch (error) {
    throw error
  }
}
